import { PostProperties } from "../types";
import image from "../img/lostGemMikeHuckaby.jpg";

const post: PostProperties = {
  id: 18,
  title: "Mike Huckaby - Reverse, Paris One (10.2010)",
  content:
    "Starting his career in the late 1980s, Mike Huckaby managed to become one of the pioneers of the Detroit sound. Teaching courses in music production for the non-profit Youthville programme, Mike Huckaby was truly one-of-a-kind person. R.I.P.",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/mike-huckaby-reverse-paris-one-102010",
  category: "Lost Gem",
  translationsBg: {
    content:
      "Стартирайки кариерата си в края на 80-те, Mike Huckaby успява да се наложи като един от пионерите на детройтския звук. Преподавайки курсове по музикална продукция в рамките на нестопанската програма Youthville, Mike Huckaby беше наистина неповторима личност. R.I.P.",
  },
};

export default post;
